import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO44 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK004-4.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO44
